























































import './KisweOnAirButton.scss'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'KisweOnAirButton',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String as () => 'xs'|'sm'|'md'|'lg'|'xl',
      required: false,
      default: 'md'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    activeLabel: {
      type: String,
      required: false,
      default: 'Live'
    },
    inactiveLabel: {
      type: String as () => string|null,
      required: false,
      default: 'Go Live'
    }
  },
  methods: {
    toggleOnAir () {
      this.$emit('input', !this.value)
    }
  }
})
